import classNames from 'classnames';
import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import { Col, Collapse, Row } from 'react-bootstrap';
import { FiCheck } from 'react-icons/fi';
import { connect } from 'react-redux';
import { branch, lifecycle, renderComponent, withHandlers, withStateHandlers } from 'recompose';
import { compose } from 'redux';
import { Icon } from '../..';
import Loading from '../../../pages/loading';
import ToggleBox from '../../toggle-box';

const ProgressGoalFilter = ({
  onProgressGoalFilterChange,
  toggleFilter,
  showFilter,
  goals
}) => {
  const goalNames = fp.flow(
    fp.map(
      ({ name }) => name
    ),
    fp.join('/')
  )(goals)
  const title = `${goalNames} Content`
  return (
    <div className='filter goal-filter'>
      <Row className='button-gutter hidden'>
        <Col xs={12}>
          <h2
            className='flexbox'
            type='button'
            onClick={toggleFilter}
            aria-expanded={showFilter}
            aria-controls='filter'>
            {
              showFilter ?
                <Icon icon='minus-large'></Icon> :
                <Icon icon='plus-large'></Icon>
            }
            <span id='label'>
              {title}
            </span>
          </h2>
        </Col>
      </Row>
      <Row className='no-gutter'>
        <Collapse id='cpd-category-filter' in={showFilter}>
          <div>
            <form id='selection-list'>
              <div>
                {
                  fp.flow(
                    fp.sortBy(goal => goal.name),
                    fp.map(
                      ({ id, name, selected }) => {
                        const boxLabel = selected ? <FiCheck /> : null
                        return <Row className={classNames('no-gutter', { selected })} id='selection' key={id} onClick={
                          () => {
                            onProgressGoalFilterChange(id)
                          }
                        }>
                          <span id='checkbox'>
                            <ToggleBox
                              small
                              value={id}
                              label={boxLabel}
                              checked={selected} />
                          </span>
                          <span>{he.decode(name)}</span>
                        </Row>
                      }
                    )
                  )(goals)
                }
              </div>
            </form>
          </div>
        </Collapse>
      </Row>
    </div>
  )
}

const getUpdatedGoals = (goals, goalIdToToggle) => fp.flow(
  fp.map(
    (goal) => ({
      ...goal,
      selected: goal.id === goalIdToToggle ? !goal.selected : goal.selected
    })
  )
)(goals)

const mapStateToProps = ({ industry, user }, { showAllGoals }) => {
  const industriesWithCpdCategorys = industry.industriesWithCpdCategorys
  const userProfile = user.profile
  const userGoalIds = fp.flow(
    fp.get('trainingPlans'),
    fp.flatMap('goals'),
    fp.map('goalId')
  )(userProfile)
  const allGoals = fp.uniqBy('id')(fp.flatMap('goals')(industriesWithCpdCategorys))
  const userGoals = fp.filter(
    ({ id }) => fp.includes(id)(userGoalIds)
  )(allGoals)
  return {
    userProfile,
    industriesWithCpdCategorys,
    goals: showAllGoals ? allGoals : userGoals
  }
}

export default compose(
  connect(mapStateToProps),
  branch(
    ({ industriesWithCpdCategorys, userProfile }) => !(userProfile && industriesWithCpdCategorys && industriesWithCpdCategorys.length > 0),
    renderComponent(Loading)
  ),
  withStateHandlers(
    {
      showFilter: true
    },
    {
      toggleFilter: ({ showFilter }) => () => ({
        showFilter: !showFilter
      })
    }
  ),
  withStateHandlers(
    ({ goals }) => ({
      goals: fp.flow(
        fp.map(
          (goal) => ({
            ...goal,
            selected: false
          })
        )
      )(goals)
    }),
    {
      setGoals: () => (goals) => ({
        goals
      }),
      resetGoals: ({ goals }) => ({ goalIds }) => ({
        goals: fp.flow(
          fp.map(
            (goal) => ({
              ...goal,
              selected: fp.includes(goal.id)(goalIds)
            })
          )
        )(goals)
      })
    }
  ),
  withHandlers({
    onProgressGoalFilterChange: ({ onChange, goals, setGoals }) => (goalId) => {
      const updatedGoals = getUpdatedGoals(goals, goalId)
      setGoals(updatedGoals)
      const selectedGoalIds = fp.flow(
        fp.filter('selected'),
        fp.map('id')
      )(updatedGoals)
      onChange({
        goalIds: selectedGoalIds
      })
    }
  }),
  lifecycle({
    componentDidUpdate(prevStat) {
      const { filter, resetGoals } = this.props
      if (!fp.isEqual(filter)(prevStat.filter)) {
        resetGoals(filter)
      }
    }
  })
)(ProgressGoalFilter)


// WEBPACK FOOTER //
// ./src/containers/components/filters/partials/progress-goal-filter.js